var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-group-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "info-banner" },
          [
            _c("a-alert", {
              attrs: {
                message: "Template Group Analytics Hakkında",
                description:
                  "Template group analytics için Meta'da oluşturulmuş template group ID'lerini girmeniz gerekmektedir. Maksimum 10 grup girebilirsiniz. Analytics verileri günlük granularity ile döner ve 90 günlük geçmiş verisine erişebilirsiniz.",
                type: "info",
                "show-icon": "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group-selector" },
          [
            _c("label", [
              _vm._v("Template Group ID'leri (virgülle ayırın, maksimum 10)"),
            ]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: "Örn: 1044106240855852, 1044106240855853" },
              on: { pressEnter: _vm.parseAndFetch },
              model: {
                value: _vm.groupIdsInput,
                callback: function ($$v) {
                  _vm.groupIdsInput = $$v
                },
                expression: "groupIdsInput",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "fetch-btn",
                attrs: { type: "primary", disabled: !_vm.groupIdsInput },
                on: { click: _vm.parseAndFetch },
              },
              [_vm._v("\n                Verileri Getir\n            ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading && _vm.data && _vm.data.data && _vm.data.data.length > 0
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Grafik Görünümü" },
                            expression: "{ content: 'Grafik Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames: !_vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = false)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Tablo Görünümü" },
                            expression: "{ content: 'Tablo Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = true)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Excel İndir" },
                            expression: "{ content: 'Excel İndir' }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Gönderilen",
                      value: _vm.totalSent,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Teslim Edilen",
                      value: _vm.totalDelivered,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Okunma",
                      value: _vm.totalRead,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Okunma Oranı",
                      value: _vm.readRate,
                      unit: "%",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.tableMode
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: "Template Group Performansı",
                          "x-axis-data": _vm.getXAxisData(),
                          legends: ["Gönderilen", "Teslim Edilen", "Okunmuş"],
                          colors: ["#37A2FF", "#80FFA5", "#FFBF00"],
                          series: _vm.getSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.groupBreakdown && Object.keys(_vm.groupBreakdown).length > 0
                ? _c("div", { staticClass: "group-breakdown" }, [
                    _c("h3", [_vm._v("Grup Bazlı Performans")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "group-cards" },
                      _vm._l(_vm.groupBreakdown, function (value, groupId) {
                        return _c(
                          "div",
                          { key: groupId, staticClass: "group-card" },
                          [
                            _c("div", { staticClass: "group-id" }, [
                              _vm._v("Grup: " + _vm._s(groupId)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "group-stats" }, [
                              _c("div", { staticClass: "stat" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Gönderilen:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(value.sent)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "stat" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Teslim:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(value.delivered)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "stat" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Okunma:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(value.read)),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description:
                      "Template group analytics verisi bulunamadı. Template group ID'lerini belirleyerek veri çekebilirsiniz.",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }